import React, {useEffect, useState} from "react";
import {  useSelector } from 'react-redux';
import {fetchForums, FORUMS_PAGE_COUNT} from './actions';
import {getForums, getForumsFetching, getForumsHasMore} from './reducer';
import "./style.css";
import {Button, Divider, Rating} from "semantic-ui-react";
import CalendarIcon from '../../icons/calendar-icon.png';
import { ReactComponent as Calendar } from '../../icons/calendar-bookmark-icon.svg';
import { ReactComponent as ArrowAsia } from '../../icons/arrow-icon-red.svg';

import { ReactComponent as ArrowGras } from '../../icons/arrow-icon-green.svg';
import InfiniteView from "../../components/InfiniteView";
import SadIconAsia from '../../icons/sad-icon.png';
import SadIconGras from "../../icons/sad-icon-green.png";

import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import {getTypeExhibition} from "../Home/reducer";
import BookmarkComponent from "../../components/Bookmark";
import { ReactComponent as ArrowWhite } from '../../icons/vector-expo-white.svg';

export function ForumCard(props) {
    const {forum, showDate, navigate} = props;
    const eventDate =
        forum.event_date.split("-")[2] + "." +
        forum.event_date.split("-")[1] + "." +
        forum.event_date.split("-")[0];

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const dataExhibition = {
        asia: {
            arrowIcon: (props) => <ArrowAsia {...props} />,
        },
        gras: {
            arrowIcon: (props) => <ArrowGras {...props} />,
        },
    }



    const Arrow = (props) => dataExhibition[typeExhibition].arrowIcon(props);
    return (
        <div className='bookmark-container'>
            <div className="bookmark">
                <div className={`bookmark-topbar ${typeExhibition}`}>
                    <div className='bookmark-topbar-column'>
                        <div className='bookmark-topbar-first-row'>
                            <span className='bookmark-topbar-event'>{forum.event_name}</span>
                            <div className={'box-one'}>
                                <Rating className={`rating-forum-card ${typeExhibition}`} maxRating={5}
                                        clearablesize="large" disabled
                                        defaultRating={forum.rating.avg_value}/>
                                <BookmarkComponent
                                    bookmark_using_for="forums"
                                    id={forum.id}
                                    {...props}
                                />
                            </div>
                        </div>
                        <div className='bookmark-topbar-second-row'>
                            <div className={'box-one'}>
                                <Calendar className="calendar-icon"/>

                                    <span className='header-bookmark-text bookmark-date'>
                                {eventDate}
                            </span>
                                <span className='header-bookmark-text bookmark-time'>
                            {forum.event_time_from + ' - ' + forum.event_time_to}
                        </span>
                            </div>
                            <div className="viewbutton" onClick={() => navigate(`/business-program/event/${forum.id}`)}>
                                <ArrowWhite className='bookmark-arrow'/>
                                <Button id='bookmark-view'>
                                    <span className={`bookmark-text-span ${typeExhibition}`}>{t("look")}</span>
                                </Button>
                            </div>
                        </div>
                    </div>


                </div>
                <div className={'bookmark-inside-all'}>
                    <div className="bookmark-inside">
                        <div id='bookmark-name'
                             className="bookmark-text forum-name">{languageString === "en" ? forum.name_en : forum.name}</div>
                        <div className='dividing-line'></div>
                        <span
                            className="bookmark-text hall-name">{languageString === "en" ? forum.event_placement_name_en : forum.event_placement_name}</span>
                    </div>
                    <div className="bookmark-inside-text">
                        <p className="bookmark-text desc-text" dangerouslySetInnerHTML={{ __html: languageString === "en" ? forum.excerpt_en : forum.excerpt }}>

                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default function BusinessProgram(props) {
    const { location, dispatch, parentView, filter, routeAction, isPageReloaded, previousLocations, mixpanel } = props;
    const [activeButton, setActiveButton] = useState(null);
    const forums = useSelector((state) => getForums(state.forums));
    const isFetching = useSelector((state) => getForumsFetching(state.forums));
    const hasMore = useSelector((state) => getForumsHasMore(state.forums));

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    function ForumsList(props) {
        const {forums, title, showDate} = props;
        return (
            !navigator.onLine
                ? <div className='view-bookmarks'>
                    <img src={SadIcon} alt={""}/>
                    <span className='text-bookmark'>{t("noForums")}</span>
                </div>
                : <div>
                    {forums ? forums.map((element) => (
                        <ForumCard
                            key={element.id}
                            forum={element}
                            showLoader
                            showDate={showDate}
                            {...props}
                        />
                    )) : ''}
                </div>
        );
    }

    const handleButtonClick = (index, handleChangePage) => {
        setActiveButton(index)
        handleChangePage()
    }

    const handleChangePage23October = () => {
        readForums(1, );
    }

    const handleChangePage24October = () => {
        readForums(1, );
    }

    const handleChangePage25October = () => {
        readForums(1, );

    }
    useEffect(() => {
        const mustReload = previousLocations.length > 1
            && previousLocations[1].location.pathname.slice(0, 24) !== "/business-program/event/";

        if ( routeAction === 'PUSH' || isPageReloaded || mustReload) {
            window.scrollTo(0, 0);
            handleChangePage23October();
            setActiveButton('2024-10-23');
        } else {
            if (!mustReload) {
                const prevForumId = previousLocations[1].location.pathname.slice(24);
                const prevForum = forums.find((obj) => obj.id === prevForumId);
                setActiveButton(prevForum.event_date);
            }

        }

        if (mixpanel) {
            mixpanel.track('View. Business Program')
        }
    }, []);

    const readForums = (page, ondate)  => {
        const params = {
            page,
            per_page: FORUMS_PAGE_COUNT,
            order: 'asc',
            orderby: 'event_date, event_time_from',
            event: typeExhibition.toUpperCase() === 'ASIA' ?  'ASIAEXPO 2026' : 'GRAS 2025',
            lang: languageString,
        };
        // if (!parentView)
        //     params['event_date'] = ondate;
        if (filter && filter.length > 0)
            params['filter'] = filter;

        dispatch(fetchForums(params));
    }

    const loadMore = () => readForums(Math.round(forums.length / FORUMS_PAGE_COUNT) + 1);

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const dataExhibitions = {
        asia: {
            sadIcon: SadIconAsia,
        },
        gras: {
            sadIcon: SadIconGras,
        }
    }

    useEffect(() => {
        readForums(1)
    }, [typeExhibition, dispatch])

    return (
        <>
            <InfiniteView
                dataLength={forums.length}
                nextFetch={loadMore}
                hasMore={hasMore}
                dataList={(
                    <ForumsList
                        showDate={!!parentView}
                        forums={forums}
                        {...props}
                    />
                )}
                hideEndMessage={true}
                mustAuth={false}
                isLoading={isFetching}
                loaderText={t("loadForums") + "..."}
                zeroText={ !isFetching ? (
                    <div className='view-bookmarks'>
                        <img width={50} height={50} src={dataExhibitions[typeExhibition].sadIcon} alt={""}/>
                        <span className='text-bookmark'>{t("noForums")}</span>
                    </div>
                ) : ""}
            />
            {/*<div className='view-bookmarks'>*/}
            {/*    <img src={SadIcon} alt={""}/>*/}
            {/*    <span className='text-bookmark'>{textData[typeExhibition].info}</span>*/}
            {/*</div>*/}
        </>
    );
}
